import React from "react";
import { Button, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./index.scss";

const Pagina404: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container className="text-center mt-5 pagina-404">
      <div className="text-center erro-404">
        <h3>
          <b>Está página não está disponível</b>
        </h3>
        <p>
          O link pode não estar funcionando ou a página pode não existir.
          Verifique se o link está correto e tente novamente.
        </p>
        <Button className="btn-primary" onClick={() => { navigate("/") }}>
          Voltar a página principal
        </Button>
      </div>
    </Container>
  );
};

export default Pagina404;
